export const CUT_MUSIC_EXAMPLE_IMAGES = {
  SHIFT: '/assets/img/cut_music_examples/shift-illustration-v2.png',
  DROP: '/assets/img/cut_music_examples/drop-illustration-v2.png',
  EXAMPLE_0SEC: '/assets/img/cut_music_examples/example-0sec-v2.png',
  EXAMPLE_30SEC: '/assets/img/cut_music_examples/example-30sec-v2.png',
  EXAMPLE_60SEC: '/assets/img/cut_music_examples/example-60sec-v2.png',
};

export const DATA_TEST_IDS = {
  INTRO: 'cut_music_help_intro',
  LIST: 'cut_music_help_list',
  OVERLAP_TITLE: 'cut_music_help_overlap_title',
  SHIFT_BLOCK: 'cut_music_help_shift_block',
  SHIFT_TITLE: 'cut_music_help_shift_title',
  SHIFT_DESCRIPTION: 'cut_music_help_shift_description',
  SHIFT_IMAGE: 'cut_music_help_shift_image',
  DROP_BLOCK: 'cut_music_help_drop_block',
  DROP_TITLE: 'cut_music_help_drop_title',
  DROP_DESCRIPTION: 'cut_music_help_drop_description',
  DROP_IMAGE: 'cut_music_help_drop_image',
  EXAMPLE_CONTENT: 'cut_music_help_example_content',
  EXAMPLE_DESCRIPTION: 'cut_music_help_example_description',
  EXAMPLE_0_IMAGE: 'cut_music_help_example_0_image',
  EXAMPLE_30_IMAGE: 'cut_music_help_example_30_image',
  EXAMPLE_60_IMAGE: 'cut_music_help_example_60_image',
  EXAMPLE_PANEL: 'cut_music_help_example_panel',
  EXAMPLE_TOGGLE: 'schedule_help_example_toggle',
  EXAMPLE_CONTENT_WRAPPER: 'cut_music_help_example_content_wrapper',
};
